import styles from './FormElement.module.scss';

export default function FormElement({ label, desc, children }) {
    return (
        <div className={styles.redlFormElement}>
            <label className={styles.redlFormElementLabel}>{(label === 'slug') ? 'url' : label}</label>
            {children}
            {desc ? <span className={styles.redlFormElementDesc}>{desc}</span> : null}
        </div>
    );
}